// extracted by mini-css-extract-plugin
export default {"new-destination":"DestinationUrlLabelList_new-destination__+-yOy","loading-spinner":"DestinationUrlLabelList_loading-spinner__znjfL"};